import { Link } from 'react-router-dom';

import '../styles/summary-card.css';

// TSS vite/01 — common presentational frame for a home "summary" panel: an
// icon + title + count in the header, an arbitrary body (a preview list or a
// loading/empty/error state), and an optional footer CTA link.
//
// Entity-agnostic on purpose (no data, no fetching, no endpoint knowledge) so
// any feature can wrap its own summary in it — TSS 01 §"start as feature,
// promote to common/ when a second feature needs the same thing" (parcerías +
// cowhousing both do). Row/state classes live in styles/summary-card.css and
// are used by the feature bodies rendered as children.
export default function SummaryCard({ icon, title, count, to, ctaLabel = 'Ver más →', children }) {
    return (
        <section className="summary-card">
            <header className="summary-card__head">
                {icon && <span className="summary-card__icon">{icon}</span>}
                <h2 className="summary-card__title">{title}</h2>
                {count != null && <span className="summary-card__count">{count}</span>}
            </header>

            <div className="summary-card__body">{children}</div>

            {to && (
                <Link to={to} className="summary-card__cta">{ctaLabel}</Link>
            )}
        </section>
    );
}
